// extracted by mini-css-extract-plugin
export default {"Single_Story":"Story_Single_Story__76qMb","Single_Story_Img":"Story_Single_Story_Img__yLjH7","Single_Story_Name":"Story_Single_Story_Name__cUwxN"};